import { useSelector, useDispatch } from 'react-redux';
import { Message } from 'stompjs';
import { append, remove } from '../store/onlineUsersSlice';
import { updateLobbiesList, removeLobbyFromList } from '../store/lobbySlice';
import { RootState } from '../store/store';

type MessageStatus = 'JOIN' | 'LEFT' | 'LOBBY_UPDATE' | 'DELETE_LOBBY';

interface BaseMessage {
  user: string;
  status: MessageStatus;
}

interface JoinMessage extends BaseMessage {
  status: 'JOIN';
}

interface LeftMessage extends BaseMessage {
  status: 'LEFT';
}

interface LobbyUpdateMessage extends BaseMessage {
  status: 'LOBBY_UPDATE';
  lobbyId: string;
  name: string;
  participantCount: number;
  passwordProtected: boolean;
}

interface DeleteLobbyMessage extends BaseMessage {
  status: 'DELETE_LOBBY';
  lobbyId: string;
}

type PublicMessage = JoinMessage | LeftMessage | LobbyUpdateMessage | DeleteLobbyMessage;

const usePublicMessageHandler = () => {
  const dispatch = useDispatch();
  const username = useSelector((state: RootState) => state.onlineUsers.username);

  const onMessageReceived = (payload: Message): void => {
    console.log(
      '%cWsContainer::onMessageReceived:::::::::::::::::::::::::' + payload.body,
      'background-color: lightblue'
    );

    const message: PublicMessage = JSON.parse(payload.body);
    const { user, status } = message;

    switch (status) {
      case 'JOIN':
        if (username !== user) {
          console.log(`User ${user} joined.`);
          dispatch(append(user));
        }
        break;

      case 'LEFT':
        console.log(`User ${user} left.`);
        dispatch(remove(user));
        break;

      case 'LOBBY_UPDATE': {
        const { lobbyId, name, participantCount, passwordProtected } = message;
        dispatch(updateLobbiesList({ lobbyId, name, participantCount, passwordProtected }));
        break;
      }

      case 'DELETE_LOBBY': {
        const { lobbyId } = message;
        dispatch(removeLobbyFromList({ lobbyId }));
        break;
      }

      default:
        console.warn('Unknown message status:', status);
    }
  };

  return onMessageReceived;
};

export default usePublicMessageHandler;